import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { DesignIcon, PencilIcon } from 'assets/icons'
import { adminCustomPageUrl } from 'config/constants/urls'
import ListMenuButton from 'src/components/PageActions/ListMenuButton'
import PageActions from 'src/components/PageActions'

const CustomPageActions = ({ page }) => (
   <PageActions
      editMenuOptions={
         <>
            <Link to={`${adminCustomPageUrl(page)}/edit`}>
               <ListMenuButton
                  name="Open in Visual Editor"
                  description="Edit the content, design, and layout for this page"
                  icon={(
                     <DesignIcon
                        width="16px"
                        height="16px"
                        color="#aaa"
                     />
                  )}
               />
            </Link>
            <Link to={adminCustomPageUrl(page)}>
               <ListMenuButton
                  name="Page Info & Settings"
                  description="Edit the settings for this page"
                  icon={(
                     <PencilIcon
                        width="16px"
                        height="16px"
                        color="#aaa"
                     />
                  )}
               />
            </Link>
         </>
      }
   />
)

CustomPageActions.propTypes = {
   page: PropTypes.object.isRequired
}

export default CustomPageActions
